var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ModelDto } from './model';
import { IsNotEmpty, IsUrl, IsString, IsNumber, IsEmpty, IsOptional, IsEnum, IsArray, ValidateIf } from 'class-validator';
import { merge as deepMerge } from 'lodash';
export var PlatformAccessStatus;
(function (PlatformAccessStatus) {
    PlatformAccessStatus[PlatformAccessStatus["OPEN"] = 1] = "OPEN";
    PlatformAccessStatus[PlatformAccessStatus["PARTIALLY_OPEN"] = 2] = "PARTIALLY_OPEN";
    PlatformAccessStatus[PlatformAccessStatus["CLOSED"] = 3] = "CLOSED";
    PlatformAccessStatus[PlatformAccessStatus["DISTRICT"] = 4] = "DISTRICT";
    PlatformAccessStatus[PlatformAccessStatus["CANTON"] = 5] = "CANTON";
})(PlatformAccessStatus || (PlatformAccessStatus = {}));
export var PlatformRole;
(function (PlatformRole) {
    PlatformRole[PlatformRole["ADMINISTRATOR"] = 1] = "ADMINISTRATOR";
    PlatformRole[PlatformRole["MODERATOR"] = 2] = "MODERATOR";
    PlatformRole[PlatformRole["MEMBER"] = 3] = "MEMBER";
})(PlatformRole || (PlatformRole = {}));
export var PlatformUserFilters;
(function (PlatformUserFilters) {
    PlatformUserFilters[PlatformUserFilters["ALL"] = 1] = "ALL";
    PlatformUserFilters[PlatformUserFilters["MY_NEIGHBOURHOOD"] = 2] = "MY_NEIGHBOURHOOD";
})(PlatformUserFilters || (PlatformUserFilters = {}));
export var PlatformSettingsPaths;
(function (PlatformSettingsPaths) {
    PlatformSettingsPaths["PLATFORM_ROOMS_ENABLED"] = "rooms.enabled";
})(PlatformSettingsPaths || (PlatformSettingsPaths = {}));
var PlatformDto = /** @class */ (function (_super) {
    __extends(PlatformDto, _super);
    function PlatformDto(platform) {
        var _a, _b;
        var _this = _super.call(this, platform) || this;
        if (platform) {
            _this.name = platform === null || platform === void 0 ? void 0 : platform.name;
            _this.slug = platform.slug;
            _this.accessStatus = platform.access_status;
            _this.description = platform.description;
            _this.coordinates = platform.coordinates ? (Array.isArray(platform.coordinates) ? platform.coordinates : JSON.parse(platform.coordinates)) : [];
            _this.logo = platform.logo;
            _this.profileImage = platform.profile_image;
            _this.attachments = (_b = (_a = platform.attachments) === null || _a === void 0 ? void 0 : _a.map(function (attachment) { return attachment.id; })) !== null && _b !== void 0 ? _b : [];
            if (platform.parent_platform) {
                _this.parentPlatformId = platform.parent_platform.id;
            }
        }
        else {
            _this.accessStatus = 0;
            _this.attachments = [];
            _this.coordinates = [[0, 0]];
        }
        return _this;
    }
    PlatformDto.prototype.setAttachments = function (attachments) {
        this.attachments = attachments.map(function (attachment) { return attachment.id; });
    };
    PlatformDto.prototype.toRestModel = function () {
        var model = _super.prototype.toRestModel.call(this);
        model.name = this.name;
        model.description = this.description;
        model.access_status = this.accessStatus;
        model.logo = this.logo;
        model.profile_image = this.profileImage;
        model.parent_platform_id = this.parentPlatformId;
        model.attachments = this.attachments;
        model.slug = this.slug;
        return model;
    };
    PlatformDto.prototype.toGqlModel = function (merge) {
        var model = _super.prototype.toGqlModel.call(this, merge);
        model.name = this.name;
        model.slug = this.slug;
        model.access_status = this.accessStatus;
        model.description = this.description;
        model.logo = this.logo;
        model.profile_image = this.profileImage;
        if (this.coordinates) {
            model.coordinates = this.coordinates;
        }
        if (this.parentPlatformId) {
            model.parent_platform_id = this.parentPlatformId;
        }
        return deepMerge(model, merge);
    };
    __decorate([
        IsString(),
        IsNotEmpty(),
        __metadata("design:type", String)
    ], PlatformDto.prototype, "name", void 0);
    __decorate([
        IsEmpty(),
        ValidateIf(function (p) { return p.isNew; }),
        __metadata("design:type", String)
    ], PlatformDto.prototype, "slug", void 0);
    __decorate([
        IsEnum(PlatformAccessStatus),
        __metadata("design:type", Number)
    ], PlatformDto.prototype, "accessStatus", void 0);
    __decorate([
        IsString(),
        __metadata("design:type", String)
    ], PlatformDto.prototype, "description", void 0);
    __decorate([
        IsUrl(),
        IsOptional(),
        __metadata("design:type", String)
    ], PlatformDto.prototype, "logo", void 0);
    __decorate([
        IsUrl(),
        IsOptional(),
        __metadata("design:type", String)
    ], PlatformDto.prototype, "profileImage", void 0);
    __decorate([
        IsNumber(),
        IsOptional(),
        __metadata("design:type", Number)
    ], PlatformDto.prototype, "parentPlatformId", void 0);
    __decorate([
        IsArray(),
        IsOptional(),
        __metadata("design:type", Array)
    ], PlatformDto.prototype, "attachments", void 0);
    return PlatformDto;
}(ModelDto));
export { PlatformDto };
